// Generated by purs version 0.15.15
var AnchorStart = /* #__PURE__ */ (function () {
    function AnchorStart() {

    };
    AnchorStart.value = new AnchorStart();
    return AnchorStart;
})();
var AnchorMiddle = /* #__PURE__ */ (function () {
    function AnchorMiddle() {

    };
    AnchorMiddle.value = new AnchorMiddle();
    return AnchorMiddle;
})();
var AnchorEnd = /* #__PURE__ */ (function () {
    function AnchorEnd() {

    };
    AnchorEnd.value = new AnchorEnd();
    return AnchorEnd;
})();
var showTextAnchor = {
    show: function (v) {
        if (v instanceof AnchorStart) {
            return "Start";
        };
        if (v instanceof AnchorMiddle) {
            return "AnchorMiddle";
        };
        if (v instanceof AnchorEnd) {
            return "End";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.TextAnchor (line 16, column 10 - line 19, column 23): " + [ v.constructor.name ]);
    }
};
var printTextAnchor = function (v) {
    if (v instanceof AnchorStart) {
        return "start";
    };
    if (v instanceof AnchorMiddle) {
        return "middle";
    };
    if (v instanceof AnchorEnd) {
        return "end";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.TextAnchor (line 22, column 19 - line 25, column 21): " + [ v.constructor.name ]);
};
var eqTextAnchor = {
    eq: function (x) {
        return function (y) {
            if (x instanceof AnchorStart && y instanceof AnchorStart) {
                return true;
            };
            if (x instanceof AnchorMiddle && y instanceof AnchorMiddle) {
                return true;
            };
            if (x instanceof AnchorEnd && y instanceof AnchorEnd) {
                return true;
            };
            return false;
        };
    }
};
export {
    AnchorStart,
    AnchorMiddle,
    AnchorEnd,
    printTextAnchor,
    eqTextAnchor,
    showTextAnchor
};
